import { createReducer, updateDeepState } from '../handlers'
import types from './types'

// Store temporary data for redirects or registrations
const initialState = {}

/**
 * Add temporary data
 * @param {Object} action
 * @param {Object<initialState>} action.data
 */
const add = (state, action) => {
  const { data } = action

  return updateDeepState(state, data)
}

const remove = () => {
  return {}
}

export default createReducer(initialState, {
  [types.add]: add,
  [types.remove]: remove,
})
